import { FileExplorer } from "@/modules/images/components/file-explorer";
import { FunctionComponent } from "react";

export const ImagesRoute: FunctionComponent = () => {
	return <FileExplorer />;
};
